import { observable, computed, toJS } from 'mobx';
import axios from 'axios'

class Nav {
  
  @observable navs = []
  @observable filter
  
  constructor(){

    this.navs = []
    
    axios.get('https://holdmyticket.com/api/public/documents/getnav')
    .then((response) => {
      
      var docs = response.data.children
      
      for(var k1 in docs.children){
        docs.children[k1].lower = docs.children[k1].lower.replace(/ /g, '-');
        for(var k2 in docs.children[k1].children)
          docs.children[k1].children[k2].lower = docs.children[k1].children[k2].lower.replace(/ /g, '-');
      }
      
      this.navs = response.data.children
      // console.log('navs', toJS(this.navs))
    })
    .catch(function (error) {
      console.log(error);
    })
    
  }
  
  @computed get get_list(){
    
    return toJS(this.navs)
    
  }

}

export default Nav


// WEBPACK FOOTER //
// ./src/stores/nav.js